import $ from 'jquery';

const defaults = {
    credits: {
        enabled: false
    },
    drilldown: false,
    chart: {
        style: {
            fontFamily: 'proximanova-regular'
        },
        height: window.innerWidth <= 767 ? 220 : null,
        marginTop: 40,
        marginRight: 30,
        backgroundColor: 'transparent',
        events: {
            redraw: function () {
                var chart = this;
                var offset = chart.series[0].pointXOffset;
                var $startPoint = $(chart.container).parents('.highcharts-container').find('.highcharts-startpoint');

                $startPoint.css({
                    top: chart.yAxis[0].toPixels(0),
                    left: chart.xAxis[0].toPixels(1) + offset
                });

                if (chartRanges.length) {
                    ranges(chart, chartRanges);
                }
            }
        }
    },
    title: {
        text: null
    },
    legend: {
        enabled: false
    },
    tooltip: {
        enabled: true,
        shared: true,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        useHTML: true,
        positioner: function (boxWidth, boxHeight, point) {
            return { x: point.plotX - boxWidth / 2 + 70, y: -1000000 };
        }
    },
    plotOptions: {
        column: {
            cursor: 'pointer',
            stacking: 'normal',
            pointPadding: -0.1,
            pointRange: 1,
            events: {
                click: plotClick
            },
            states: {
                hover: {
                    cursor: 'pointer'
                },
                select: {
                    color: null,
                    borderColor: null
                }
            }
        },
        line: {
            enableMouseTracking: false,
            marker: {
                enabled: false
            },
            dashStyle: 'ShortDot'
        }
    },
    dataStartIndex: 0,
    xAxis: {
        title: {
            text: 'År',
            align: 'high',
            offset: 0,
            rotation: 0,
            x: 20,
            y: 7,
            style: {
                fontWeight: 'bold',
                color: '#333333',
                fontSize: '11px',
                overflow: 'visible'
            }
        },
        categories: [],
        lineColor: '#ececec',
        labels: {
            enabled: true,
            useHTML: true,
            autoRotation: false,
            style: {
                overflow: 'visible'
            }
        },
        tickColor: 'transparent'
    },
    yAxis: {
        min: 0,
        title: {
            text: 'kr.',
            align: 'high',
            offset: 0,
            rotation: 0,
            y: -18,
            x: -15,
            useHTML: true,
            style: {
                fontWeight: 'bold',
                color: '#333333',
                fontSize: '14px',
                width: '20px',
                overflow: 'hidden'
            }
        },
        labels: {
            formatter: function () {
                return ('' + this.value).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, function ($1) {
                    return $1 + '.';
                });
            },
            style: {
                fontWeight: 'bold',
                fontSize: '10px'
            }
        },
        gridLineColor: '#ececec',
        lineWidth: 1,
        lineColor: '#ececec'
    },
    series: [
        {
            id: 'Payout',
            type: 'column',
            name: 'Udbetaling',
            color: '#D0E5CD',
            data: []
        },
        {
            id: 'AoLoebende',
            type: 'column',
            name: 'AlLoebende',
            color: '#A0CB9B',
            data: []
        },
        {
            id: 'Loebende',
            type: 'column',
            name: 'Ekstra udbetaling',
            color: '#72B269',
            data: []
        },
        {
            id: 'Low',
            type: 'line',
            name: 'Lavere end forventet',
            color: '#eb5656',
            data: []
        },
        {
            id: 'High',
            type: 'line',
            name: 'Højere end forventet',
            color: '#1877a3',
            data: []
        }
    ],
    responsive: {
        rules: [
            {
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    chart: {
                        width: 650
                    }
                }
            }
        ]
    }
};

let scope = null;
let $tooltip = null;

function onChartLoad(scope, chart) {
    $(scope).removeClass('loading');
}

function init(chartScope, chartData = {}) {
    var options = $.extend(true, chartData, defaults);
    scope = chartScope;

    const chartHeight = $(scope).attr('data-chart-height');
    if (chartHeight) {
        options.chart.height = chartHeight;
    }

    $(scope)
        .find('.highcharts-container-graph')
        .highcharts(options, (chart) => {
            onChartLoad(scope, chart);

            setTimeout(function () {
                $(window).trigger('resize');
            }, 1);

            customTooltips(chartScope, chart);

            $(window).resize(function () {
                chart.redraw();
            });

            $tooltip = $(scope).find('.highcharts-tooltip');
            $(window, document).on('click.tooltip', function () {
                $tooltip = $(scope).find('.highcharts-tooltip');
                $tooltip.addClass('hide');

                $('.highcharts-point-click').removeClass('highcharts-point-click');
                $(chart.container).removeClass('highchart-plotclick');
            });
        });
}

const API = (scope) => $(scope).find('.highcharts-container-graph').highcharts();
const destroy = (scope) => API(scope).destroy();

function plotClick(event) {
    if (event.point.x === 1) {
        $('.highcharts-series-0').find('.highcharts-point:first-child').addClass('highcharts-point-click');
        $('.highcharts-series-1').find('.highcharts-point:first-child').addClass('highcharts-point-click');
    } else {
        $(event.point.graphic.element).addClass('highcharts-point-click');
    }

    $tooltip = $('.highcharts-tooltip.tooltip-id' + event.point.x);

    $(this.chart.container).addClass('highchart-plotclick');
    const tooltipWidth = parseInt($tooltip.css('maxWidth'), 10);
    const airInPx = 5;
    const chartPlotBox = this.chart.plotBox;

    let x = event.point.shapeArgs.x + chartPlotBox.x;
    if (event.point.index <= event.point.series.data.length / 2) {
        x = x + event.point.shapeArgs.width + airInPx;
    } else {
        x = x - tooltipWidth - airInPx;
    }

    event.stopPropagation();
    if (window.innerWidth <= 767) {
        $tooltip.removeClass('hide').css({
            width: '100%',
            maxWidth: '100%',
            top: 135,
            left: 0
        });
    } else {
        $tooltip.removeClass('hide');

        let top = event.point.shapeArgs.y + chartPlotBox.y - $tooltip.outerHeight() / 2;

        if (window.innerWidth <= 768) {
            top = top + 115;
        }

        $tooltip.css({
            top: top,
            left: x
        });
    }
}

let customLabels = [];
let chartRanges = [];

function resetCustomLabels(labels) {
    if (labels.length) {
        labels.forEach((path) => path.destroy());
    }

    customLabels = [];
}

function update(series) {
    $.each(series, (id, data) => {
        API(scope).get(id).setData(data, false);
    });

    if (chartRanges) {
        chartRanges = [];
        resetCustomLabels(customLabels);
    }

    API(scope).redraw();
}

function ranges(chart, data) {
    $(chart.container).find('.highcharts-axis-labels.highcharts-xaxis-labels').addClass('hide');

    resetCustomLabels(customLabels);
    chartRanges = data;

    for (let i = 0; i < data.length; i++) {
        const beforeafterspace = 0.4;
        const dashlength = 25;
        const rangeSpacer = 5;
        const spaceFromChart = 5;
        const Y = chart.chartHeight - 38 + spaceFromChart;
        let line;
        let dots;
        let text;
        let rangeFrom = undefined;
        let rangeTo = undefined;
        let color = '#333';

        if (data[i].length === 3) {
            rangeFrom = data[i][0];
            rangeTo = data[i][1];
            text = data[i][2];
        } else {
            rangeFrom = data[i][0];
            rangeTo = data[i][0];
            text = data[i][1];
            color = 'transparent';
        }

        const startX = Highcharts.charts[0].xAxis[0].toPixels(rangeFrom - beforeafterspace);
        const endX = Highcharts.charts[0].xAxis[0].toPixels(rangeTo + beforeafterspace);

        if (!text.endsWith('og frem')) {
            line = chart.renderer
                .path(['M', startX, Y, 'L', startX, Y + rangeSpacer, 'L', endX, Y + rangeSpacer, 'L', endX, Y])
                .attr({ 'stroke-width': 1, stroke: color })
                .add();

            customLabels.push(line);
        } else {
            line = chart.renderer
                .path(['M', startX, Y, 'L', startX, Y + rangeSpacer, 'L', endX - dashlength, Y + rangeSpacer])
                .attr({ 'stroke-width': 1, stroke: color })
                .add();
            dots = chart.renderer
                .path(['M', endX - dashlength, Y + rangeSpacer, 'L', endX, Y + rangeSpacer])
                .attr({ 'stroke-width': 1, stroke: color, dashstyle: 'Dot' })
                .add();

            customLabels.push(line);
            customLabels.push(dots);
        }

        const lines = line.getBBox();
        const rangeText = chart.renderer
            .text('<span class="highcharts-custom-label">' + text + '</span>', 0, 0, true)
            .attr({
                color: 'black',
                fill: '#FFFFEF'
            })
            .add();

        const txt = rangeText.getBBox();
        rangeText.attr({ x: lines.x + lines.width / 2 - txt.width / 2, y: Y + spaceFromChart + txt.height / 2 });
        customLabels.push(rangeText);
    }
}

function customTooltips(scope, chart) {
    var tips = $(scope).find('.prognose-tip');
    var active = 1;
    var counter = 1;

    if (!tips.length) {
        return;
    } else {
        tips.each(function () {
            $(this).data('tipOrder', counter);
            counter++;
        });
    }

    $(scope).find('.btn.prognose-tips:not(.has-no-tip)').show();

    tips.on('click', '.js-prognose-tip-close', function (e) {
        e.preventDefault();

        $(scope).find('.btn.prognose-tips:not(.has-no-tip)').show();
        tips.each(function () {
            $(this).fadeOut();
        });
    });

    tips.on('click', '.js-prognose-tip-next', function (e) {
        e.preventDefault();

        hide(active, tips);
        active++;
        show(active, tips);
    });

    $(scope)
        .find('.btn.prognose-tips:not(.has-no-tip)')
        .on('click', function (e) {
            e.preventDefault();

            $(this).hide();
            active = 1;
            show(active, tips);
        });

    function show(tip, tips) {
        var tipElem = tips.filter(function () {
            return $(this).data('tipOrder') == tip;
        });

        if (tipElem.data('tipinactive') != null) {
            if (tips.length > tip) {
                tip++;
                show(tip, tips);
            } else {
                $('.js-prognose-tip-close').trigger('click'); // close
            }
        } else {
            tipElem.fadeIn();
            if (tipElem.data('columnserienr') !== '' && tipElem.data('columnserienr') !== undefined) {
                const serieNr = parseInt(tipElem.data('columnserienr'), 10);
                const data = chart.series[serieNr].data;
                const tipHeight = tipElem.find('.prognose-tip-content').outerHeight() + 5;
                const leftSub = 25;
                let tipIndex = tipElem.data('columnnr');

                if (tipIndex < 0 || tipIndex > data.length) {
                    return;
                } else if (tipIndex >= data.length) {
                    tipIndex = data.length - 1;
                }

                let yPoints = data[tipIndex].stackY;
                const xPoints = data[tipIndex].x;

                if (serieNr > 1) {
                    yPoints = data[tipIndex].y;
                }

                if (tipIndex >= 0) {
                    tipElem.find('.prognose-tip-content').css({
                        top: chart.yAxis[0].toPixels(yPoints) - (tipHeight + 7) + 'px',
                        left: chart.xAxis[0].toPixels(xPoints) - leftSub + 'px'
                    });
                }
            }
        }
    }

    function hide(tip, tips) {
        tips.filter(function () {
            return $(this).data('tipOrder') == tip;
        }).fadeOut();
    }
}

const pensionForecastGraph = {
    defaults,
    init,
    API,
    destroy,
    update,
    ranges,
    customTooltips
};

pensionForecastGraph.init('.box-prognose-new');

export default pensionForecastGraph;
